<template>
  <div class="header-search">
    <i class="iconfont icon-sousuo" @click.stop="click"></i>
    <input class="searchInput" ref="searchInput" :class="{'show':show}" v-model="searchValue" type="text" @click.stop=""
           @keyup.enter="search"/>
  </div>
</template>

<script>
export default {
  name: "header-search",
  data() {
    return {
      searchValue: '',
      show: false
    }
  },
  watch: {
    show(value) {
      if (value) {
        document.body.addEventListener('click', this.close)
      } else {
        document.body.removeEventListener('click', this.close)
      }
    }
  },
  methods: {
    search() {
      this.$router.push({name: 'search', params: {words: this.searchValue}});
      this.close()
    },
    click() {
      this.searchValue = ''
      this.show = !this.show
      if (this.show) {
        this.$refs.searchInput && this.$refs.searchInput.focus()
      }
    },
    close() {
      this.$refs.searchInput && this.$refs.searchInput.blur()
      this.show = false
    }
  }
}
</script>

<style scoped lang="less">
.header-search {
  display: inline-block;
  position: relative;
}

.header-search i {
  font-size: 18px;
  position: relative;
  top: 3px;
  color: var(--text-secondary);
  cursor: pointer;
  transition: color 0.2s ease;
}

.header-search i:hover {
  color: #0d9488;
}

.searchInput {
  border: none;
  outline: none;
  overflow: hidden;
  background: transparent;
  height: 30px;
  width: 0;
  transition: .2s all;
  font-size: 14px;
  color: var(--text-primary);
}

.show {
  width: 200px;
  margin-left: 10px;
}

.searchInput:focus {
  border-bottom: 2px solid #0d9488;
}
</style>
